import React from 'react'

function Alert(props) {
    const { isOpen, message, type } = props.alert;

    return (
        <>
            {isOpen ? <div className={`alert alert-${type} position-fixed`} role="alert">
                {message}
            </div> : null}
        </>
    )
}

export default Alert
